// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"00105955","739":"ffe84e9b"}[chunkId] + ".chunk.js";
};